
import { defineComponent, ref, onMounted } from "vue";
//import Dropdown3 from "@/components/dropdown/Dropdown3.vue";
import { getCSSVariableValue } from "@/assets/ts/_utils";
import useSegip from "@/filiation/composables/useFiliation";
export default defineComponent({
  name: "widget-1",
  components: {},
  props: {
    widgetClasses: String,
    widgetColor: String,
    strokeColor: String,
  },
  setup(props) {
    const { countPersonsCenters, countCentersByPersons } = useSegip();
    const countByCenter = async () => {
      await countPersonsCenters();
    };
    onMounted(() => {
      countByCenter();
    });
    const labelColor = getCSSVariableValue("--bs-black-500");
    const borderColor = getCSSVariableValue("--bs-gray-200");

    const color = getCSSVariableValue("--bs-" + props.widgetColor);

    const strokeColor = ref(props.strokeColor);
    const options = {
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
      },
    };
    const series = [
      {
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91]
      }
    ];
    // const chartOptions = {
    //   chart: {
    //     fontFamily: "inherit",
    //     type: "bar",
    //     toolbar: {
    //       show: true,
    //     },
    //     zoom: {
    //       enabled: true,
    //     },
    //     sparkline: {
    //       enabled: true,
    //     },
    //     dropShadow: {
    //       enabled: true,
    //       enabledOnSeries: undefined,
    //       top: 2,
    //       left: 0,
    //       blur: 3,
    //       color: "blue",
    //       opacity: 0.5,
    //     },
    //   },
    //   plotOptions: {},
    //   legend: {
    //     show: true,
    //   },
    //   dataLabels: {
    //     enabled: true,
    //   },
    //   fill: {
    //     type: "solid",
    //     opacity: 1,
    //   },
    //   stroke: {
    //     curve: "smooth",
    //     show: true,
    //     width: 1,
    //     colors: [strokeColor.value],
    //   },
    //   xaxis: {
    //     categories: [
    //       "Enero",
    //       "Febrero",
    //       "Marzo",
    //       "Abr",
    //       "May",
    //       "Jun",
    //       "Jul",
    //       "Ago",
    //       "Sep",
    //       "Oct",
    //       "Nov",
    //       "Dic",
    //     ],
    //     axisBorder: {
    //       show: true,
    //     },
    //     axisTicks: {
    //       show: true,
    //     },
    //     labels: {
    //       show: true,
    //       style: {
    //         colors: "red",
    //         fontSize: "12px",
    //       },
    //     },
    //     crosshairs: {
    //       show: true,
    //       position: "front",
    //       stroke: {
    //         color: borderColor,
    //         width: 1,
    //         dashArray: 3,
    //       },
    //     },
    //   },
    //   yaxis: {
    //     min: 0,
    //     max: 80,
    //     labels: {
    //       show: true,
    //       style: {
    //         colors: labelColor,
    //         fontSize: "12px",
    //       },
    //     },
    //   },
    //   states: {
    //     normal: {
    //       filter: {
    //         type: "none",
    //         value: 0,
    //       },
    //     },
    //     hover: {
    //       filter: {
    //         type: "none",
    //         value: 0,
    //       },
    //     },
    //     active: {
    //       allowMultipleDataPointsSelection: true,
    //       filter: {
    //         type: "none",
    //         value: 0,
    //       },
    //     },
    //   },
    //   tooltip: {
    //     style: {
    //       fontSize: "12px",
    //     },
    //     y: {
    //       formatter: function (val) {
    //         return val + " privados de libertad";
    //       },
    //     },
    //     marker: {
    //       show: false,
    //     },
    //   },
    //   markers: {
    //     colors: [color],
    //     strokeColor: [strokeColor.value],
    //     strokeWidth: 3,
    //   },
    // };

    // const series = [
    //   {
    //     name: "Ingresos por mes",
    //     data: [21, 30, 45, 32, 70, 40, 40, 40, 70, 22, 41, 32],
    //   },
    // ];

    return {
      countCentersByPersons,
      series,
      options,
      // chartOptions,
    };
  },
});
